export function parseSseBlocks(buffer: string): {
  blocks: string[];
  remainder: string;
} {
  const parts = buffer.split(/\r?\n\r?\n/);
  const completeBlocks = parts.slice(0, -1);
  const remainder = parts[parts.length - 1] || '';
  return {blocks: completeBlocks, remainder};
}

export function coercePythonStyleJson(input: string): string {
  if (!input) return input;
  let out = input;
  if (out.includes("'")) {
    out = out.replace(/'/g, '"');
  }
  out = out.replace(/\bNone\b/g, 'null');
  return out;
}
